import React, { useEffect } from 'react';
import mixpanel from 'mixpanel-browser';
import axios from 'axios';
import { t } from 'i18next';
import { FontWeight, Heading } from '@lili/lili-frontend-common';
import { GreyBgCard } from './components/Card';
import { TextWithCopy } from './components/TextWithCopy';
import WireIcon from '../../assets/icons/svg/colored-icons/ic-colored-wire-icon.svg';
import { EmailSection } from './components/EmailSection';
import { useStore } from '../../store';
import { getAddressObj } from '../../helpers/address.helpers';
import PageLayout from '../../generic-components/PageLayout/PageLayout';
import { IntProviderCard } from './components/IntProviderCard';
import { BASE_URL } from '../../constants/endpoints';
import { handleDownload } from './utils';
import PageHeader from '../../generic-components/PageHeader/PageHeader';
import { LiliCard } from './components/LiliCard';

export const WireTransferNew = () => {
  const HEADER = t('WIRE_TRANSFER_HEADER');
  const { customerId } = useStore((state) => state.currUser());
  const [isEmailSent, setIsEmailSent] = React.useState(false);
  const { getPrimaryAccount, getPersonalAccountId } = useStore((state) => state);
  const [isDownloading, setIsDownloading] = React.useState(false);
  useEffect(() => {
    mixpanel.track('View Incoming Wire Screen');
    mixpanel.track('Act on Add Money Screen', { Action: 'Incoming Wire', ui_screen: 'Menu Screen' });
  }, []);

  const {
    achAccountNumber,
    wireRoutingNumber,
    bankInfo: { bank, bankInstAddress, bankInstInfo, bankInstName },
  } = getPrimaryAccount();
  const splitBankAddress = getAddressObj(bank, bankInstAddress);
  const disclaimer = {
    title: t('WIRE_DISCLAIMER_1'),
    description: t('WIRE_DISCLAIMER_2'),
  };
  const providerHeadline = t('BANKING_SERVICE');
  const wireSerivceText = t('WIRE_SERVICE_TEXT', 'Wire Transfer service provided by');

  const handleDownloadClick = async () => {
    setIsDownloading(true);
    const extId = getPersonalAccountId();
    const url = `${BASE_URL}/api/v1/user/${customerId}/${extId}/confirmation/wire/bankAccount/download`;

    try {
      const { data } = await axios(url, {
        responseType: 'blob',
        method: 'GET',
      });
      handleDownload(URL.createObjectURL(data), 'Lili Banking Domestic Wire Transfer Instructions.pdf');
      setIsDownloading(false);
    } catch (error) {
      console.error(error);
      setIsDownloading(false);
    }
  };

  const providerLines = [
    {
      boldedHeader: providerHeadline,
      header: bankInstName,
      line1: bankInstInfo,
      line2: splitBankAddress.addressLine,
      line3: splitBankAddress.stateAndZip,
    },
    {
      boldedHeader: wireSerivceText,
      header: t('WIRE_TT_2'),
      line1: t('WIRE_TT_2_LINE_1'),
      line2: t('WIRE_TT_2_LINE_2'),
      line3: t('WIRE_TT_2_LINE_3'),
    },
  ];

  const CardSubContentHeader = t('DIRECT_DEPOSIT_PAGE_SUB_CONTENT_HEADER');
  const greyBgCardtext = t('WIRE_PAGE_TEXT');
  const greyBgCardTitle = t('WIRE_PAGE_SUBHEADER');
  return (
    <PageLayout>
      <PageHeader title={HEADER} showBackButton={false} />
      <div className='flex flex-row gap-[24px] h-[78dvh]'>
        <LiliCard className='basis-[45%] h-full w-full p-[32px] flex flex-col justify-between'>
          <div className='h-full'>
            <Heading.H9 fontWeight={FontWeight.MEDIUM} id='yourAccountDetails' className='mb-[24px]'>
              {CardSubContentHeader}
            </Heading.H9>
            <TextWithCopy title={t('WIRE_ACCOUNT_NUM')} text={achAccountNumber} />
            <TextWithCopy title={t('WIRE_ROUT_NUM')} text={wireRoutingNumber ?? ''} />
          </div>
          <EmailSection
            setIsEmailSent={setIsEmailSent}
            isEmailSent={isEmailSent}
            isRefetching={isDownloading}
            isLoading={isDownloading}
            handleSendEmail={handleDownloadClick}
          />
        </LiliCard>
        <LiliCard className='basis-[55%] w-full flex flex-col p-[32px] gap-[24px]'>
          <GreyBgCard iconId='calendar' iconSrc={WireIcon} text={greyBgCardtext} title={greyBgCardTitle} />
          <IntProviderCard providerHeadline={providerHeadline} disclaimer={disclaimer} providersLines={providerLines} />
        </LiliCard>
      </div>
    </PageLayout>
  );
};
